<template>
  <div
    class="section-container"
    :class="{
      [`section-container--bg-${bgColor}`]: bgColor,
      [`section-container--bg-spacing-${height}`]: height !== 'none' && bgColor,
      [`section-container--spacing-${height}`]: height !== 'none' && !bgColor,
    }"
  >
    <SAppContainer :size :tag>
      <slot />
    </SAppContainer>
  </div>
</template>

<script setup lang="ts">
import { SAppContainer } from "@solvari/components";

withDefaults(
  defineProps<{
    bgColor?: "dark" | "light" | "primary";
    height?: "lg" | "md" | "none" | "sm";
    size?: "lg" | "md" | "sm";
    tag?: "div" | "section" | undefined;
    widePadding?: boolean;
  }>(),
  { tag: "section", height: "lg" },
);
</script>

<style lang="postcss">
.section-container {
  @apply w-full;

  &--spacing-sm {
    @apply my-4;

    @screen 1000 {
      @apply my-6;
    }
  }

  &--spacing-md {
    @apply my-8;

    @screen 1000 {
      @apply my-12;
    }
  }

  &--spacing-lg {
    @apply my-16;

    @screen 1000 {
      @apply my-20;
    }
  }

  &--bg-spacing-sm {
    @apply py-4;

    @screen 1000 {
      @apply py-6;
    }
  }

  &--bg-spacing-md {
    @apply py-8;

    @screen 1000 {
      @apply py-12;
    }
  }

  &--bg-spacing-lg {
    @apply py-16;

    @screen 1000 {
      @apply py-20;
    }
  }

  &--bg-light {
    @apply bg-slate-50;
  }

  &--bg-dark {
    @apply bg-primary-100;
  }

  &--bg-primary {
    @apply bg-primary-700;
  }
}
</style>
